import Axios from '@/plugins/Axios';
import {
  EncryptedSessionDataInterface,
  EncryptedSessionPayloadInterface,
  GetSessionData,
  GetSessionPayload,
} from '@/types';
import { AxiosResponse } from 'axios';

const encryptedEnpoind = '/encrypted-session';
const sessionEnpoint = '/session';
const doctorSessionEndpoint = '/b2b/session';

const sessionApi = {
  encryptedSessionB2B: (data: EncryptedSessionPayloadInterface) => {
    return Axios().post<EncryptedSessionDataInterface>(
      `/b2b${encryptedEnpoind}`,
      data
    );
  },
  encryptedSession: (data: EncryptedSessionPayloadInterface) => {
    return Axios().post<EncryptedSessionDataInterface>(
      `${encryptedEnpoind}`,
      data
    );
  },
  getPatientSession: (data: GetSessionPayload) => {
    return Axios().post<GetSessionData>(`${sessionEnpoint}`, data);
  },
  getDoctorSession: (data: GetSessionPayload) => {
    return Axios().post<GetSessionData>(`${doctorSessionEndpoint}`, data);
  },
};

export default sessionApi;
